(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient', './Grade'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./Grade'));
  } else {
    // Browser globals (root is window)
    if (!root.SmartCsV2Sdk) {
      root.SmartCsV2Sdk = {};
    }
    root.SmartCsV2Sdk.SmexRequest = factory(root.SmartCsV2Sdk.ApiClient, root.SmartCsV2Sdk.Grade);
  }
}(this, function(ApiClient, Grade) {
  'use strict';

  /**
   * The SmexRequest model module.
   * @module model/SmexRequest
   * @version 2.0.624
   */

  /**
   * Constructs a new <code>SmexRequest</code>.
   * @alias module:model/SmexRequest
   * @class
   * @param filename
   */
  var exports = function(filename) {








    this['filename'] = filename;











  };

  /**
   * Constructs a <code>SmexRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SmexRequest} obj Optional instance to populate.
   * @return {module:model/SmexRequest} The populated <code>SmexRequest</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) { 
      obj = obj || new exports();

      if (data.hasOwnProperty('tags')) {
        obj['tags'] = ApiClient.convertToType(data['tags'], ['String']);
      }
      if (data.hasOwnProperty('author')) {
        obj['author'] = ApiClient.convertToType(data['author'], 'String');
      }
      if (data.hasOwnProperty('category')) {
        obj['category'] = ApiClient.convertToType(data['category'], 'String');
      }
      if (data.hasOwnProperty('componentTypes')) {
        obj['componentTypes'] = ApiClient.convertToType(data['componentTypes'], ['String']);
      }
      if (data.hasOwnProperty('country')) {
        obj['country'] = ApiClient.convertToType(data['country'], 'String');
      }
      if (data.hasOwnProperty('description')) {
        obj['description'] = ApiClient.convertToType(data['description'], 'String');
      }
      if (data.hasOwnProperty('expiry')) {
        obj['expiry'] = ApiClient.convertToType(data['expiry'], 'Integer');
      }
      if (data.hasOwnProperty('filename')) {
        obj['filename'] = ApiClient.convertToType(data['filename'], 'String');
      }
      if (data.hasOwnProperty('googleDriveId')) {
        obj['googleDriveId'] = ApiClient.convertToType(data['googleDriveId'], 'String');
      }
      if (data.hasOwnProperty('grades')) {
        obj['grades'] = ApiClient.convertToType(data['grades'], [Grade]);
      }
      if (data.hasOwnProperty('language')) {
        obj['language'] = ApiClient.convertToType(data['language'], 'String');
      }
      if (data.hasOwnProperty('lppVersion')) {
        obj['lppVersion'] = ApiClient.convertToType(data['lppVersion'], 'String');
      }
      if (data.hasOwnProperty('resourceType')) {
        obj['resourceType'] = ApiClient.convertToType(data['resourceType'], 'String');
      }
      if (data.hasOwnProperty('smexCustomData')) {
        obj['smexCustomData'] = ApiClient.convertToType(data['smexCustomData'], Object);
      }
      if (data.hasOwnProperty('source')) {
        obj['source'] = ApiClient.convertToType(data['source'], 'String');
      }
      if (data.hasOwnProperty('standardSets')) {
        obj['standardSets'] = ApiClient.convertToType(data['standardSets'], ['String']);
      }
      if (data.hasOwnProperty('standardStrands')) {
        obj['standardStrands'] = ApiClient.convertToType(data['standardStrands'], ['String']);
      }
      if (data.hasOwnProperty('subjects')) {
        obj['subjects'] = ApiClient.convertToType(data['subjects'], ['String']);
      }
      if (data.hasOwnProperty('title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
    }
    return obj;
  }


  /**
   * @member {Array.<String>} tags
   */
  exports.prototype['tags'] = undefined;

  /**
   * @member {String} author
   */
  exports.prototype['author'] = undefined;

  /**
   * @member {module:model/SmexRequest.CategoryEnum} category
   */
  exports.prototype['category'] = undefined;

  /**
   * @member {Array.<module:model/SmexRequest.ComponentTypesEnum>} componentTypes
   */
  exports.prototype['componentTypes'] = undefined;

  /**
   * @member {module:model/SmexRequest.CountryEnum} country
   */
  exports.prototype['country'] = undefined;

  /**
   * @member {String} description
   */
  exports.prototype['description'] = undefined;

  /**
   * @member {Integer} expiry
   */
  exports.prototype['expiry'] = undefined;

  /**
   * @member {String} filename
   */
  exports.prototype['filename'] = undefined;

  /**
   * @member {String} googleDriveId
   */
  exports.prototype['googleDriveId'] = undefined;

  /**
   * @member {Array.<module:model/Grade>} grades
   */
  exports.prototype['grades'] = undefined;

  /**
   * @member {module:model/SmexRequest.LanguageEnum} language
   */
  exports.prototype['language'] = undefined;

  /**
   * @member {module:model/SmexRequest.LppVersionEnum} lppVersion
   */
  exports.prototype['lppVersion'] = undefined;

  /**
   * @member {module:model/SmexRequest.ResourceTypeEnum} resourceType
   */
  exports.prototype['resourceType'] = undefined;

  /**
   * @member {Object} smexCustomData
   */
  exports.prototype['smexCustomData'] = undefined;

  /**
   * @member {String} source
   */
  exports.prototype['source'] = undefined;

  /**
   * @member {Array.<String>} standardSets
   */
  exports.prototype['standardSets'] = undefined;

  /**
   * @member {Array.<String>} standardStrands
   */
  exports.prototype['standardStrands'] = undefined;

  /**
   * @member {Array.<String>} subjects
   */
  exports.prototype['subjects'] = undefined;

  /**
   * @member {String} title
   */
  exports.prototype['title'] = undefined;


  /**
   * Allowed values for the <code>category</code> property.
   * @enum {String}
   * @readonly
   */
  exports.CategoryEnum = { 
    /**
     * value: MATH
     * @const
     */
    MATH: "MATH",
    
    /**
     * value: ART
     * @const
     */
    ART: "ART",
    
    /**
     * value: SCIENCE
     * @const
     */
    SCIENCE: "SCIENCE"
  };
  /**
   * Allowed values for the <code>componentTypes</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ComponentTypesEnum = { 
    /**
     * value: LESSON
     * @const
     */
    LESSON: "LESSON",
    
    /**
     * value: ACTIVITY
     * @const
     */
    ACTIVITY: "ACTIVITY",
    
    /**
     * value: ASSESSMENT
     * @const
     */
    ASSESSMENT: "ASSESSMENT",
    
    /**
     * value: TEMPLATE
     * @const
     */
    TEMPLATE: "TEMPLATE",
    
    /**
     * value: CLASSROOM_TOOLS
     * @const
     */
    CLASSROOM_TOOLS: "CLASSROOM_TOOLS",
    
    /**
     * value: CONTENT_LIST
     * @const
     */
    CONTENT_LIST: "CONTENT_LIST",
    
    /**
     * value: RESOURCE
     * @const
     */
    RESOURCE: "RESOURCE"
  };  /**
   * Allowed values for the <code>country</code> property.
   * @enum {String}
   * @readonly
   */
  exports.CountryEnum = { 
    /**
     * value: ALGERIA
     * @const
     */
    ALGERIA: "ALGERIA",
    
    /**
     * value: ARGENTINA
     * @const
     */
    ARGENTINA: "ARGENTINA",
    
    /**
     * value: AUSTRALIA
     * @const
     */
    AUSTRALIA: "AUSTRALIA",
    
    /**
     * value: AUSTRIA
     * @const
     */
    AUSTRIA: "AUSTRIA",
    
    /**
     * value: BANGLADESH
     * @const
     */
    BANGLADESH: "BANGLADESH",
    
    /**
     * value: BELGIUM
     * @const
     */
    BELGIUM: "BELGIUM",
    
    /**
     * value: BRAZIL
     * @const
     */
    BRAZIL: "BRAZIL",
    
    /**
     * value: CANADA
     * @const
     */
    CANADA: "CANADA",
    
    /**
     * value: CHILE
     * @const
     */
    CHILE: "CHILE",
    
    /**
     * value: CHINA
     * @const
     */
    CHINA: "CHINA",
    
    /**
     * value: COLOMBIA
     * @const
     */
    COLOMBIA: "COLOMBIA",
    
    /**
     * value: CYPRUS
     * @const
     */
    CYPRUS: "CYPRUS",
    
    /**
     * value: CZECH_REPUBLIC
     * @const
     */
    CZECH_REPUBLIC: "CZECH_REPUBLIC",
    
    /**
     * value: DOMINICAN_REPUBLIC
     * @const
     */
    DOMINICAN_REPUBLIC: "DOMINICAN_REPUBLIC",
    
    /**
     * value: ECUADOR
     * @const
     */
    ECUADOR: "ECUADOR",
    
    /**
     * value: EGYPT
     * @const
     */
    EGYPT: "EGYPT",
    
    /**
     * value: ENGLAND
     * @const
     */
    ENGLAND: "ENGLAND",
    
    /**
     * value: ETHIOPIA
     * @const
     */
    ETHIOPIA: "ETHIOPIA",
    
    /**
     * value: DENMARK
     * @const
     */
    DENMARK: "DENMARK",
    
    /**
     * value: FRANCE
     * @const
     */
    FRANCE: "FRANCE",
    
    /**
     * value: FINLAND
     * @const
     */
    FINLAND: "FINLAND",
    
    /**
     * value: GERMANY
     * @const
     */
    GERMANY: "GERMANY",
    
    /**
     * value: GREECE
     * @const
     */
    GREECE: "GREECE",
    
    /**
     * value: HONG_KONG
     * @const
     */
    HONG_KONG: "HONG_KONG",
    
    /**
     * value: HUNGARY
     * @const
     */
    HUNGARY: "HUNGARY",
    
    /**
     * value: INDIA
     * @const
     */
    INDIA: "INDIA",
    
    /**
     * value: INDONESIA
     * @const
     */
    INDONESIA: "INDONESIA",
    
    /**
     * value: IRAN
     * @const
     */
    IRAN: "IRAN",
    
    /**
     * value: IRAQ
     * @const
     */
    IRAQ: "IRAQ",
    
    /**
     * value: IRELAND
     * @const
     */
    IRELAND: "IRELAND",
    
    /**
     * value: ISRAEL
     * @const
     */
    ISRAEL: "ISRAEL",
    
    /**
     * value: ITALY
     * @const
     */
    ITALY: "ITALY",
    
    /**
     * value: JAPAN
     * @const
     */
    JAPAN: "JAPAN",
    
    /**
     * value: KAZAKHSTAN
     * @const
     */
    KAZAKHSTAN: "KAZAKHSTAN",
    
    /**
     * value: KOREA_REPUBLIC_OF
     * @const
     */
    KOREA_REPUBLIC_OF: "KOREA_REPUBLIC_OF",
    
    /**
     * value: LATVIA
     * @const
     */
    LATVIA: "LATVIA",
    
    /**
     * value: LITHUANIA
     * @const
     */
    LITHUANIA: "LITHUANIA",
    
    /**
     * value: MALAYSIA
     * @const
     */
    MALAYSIA: "MALAYSIA",
    
    /**
     * value: MEXICO
     * @const
     */
    MEXICO: "MEXICO",
    
    /**
     * value: MOROCCO
     * @const
     */
    MOROCCO: "MOROCCO",
    
    /**
     * value: MYANMAR
     * @const
     */
    MYANMAR: "MYANMAR",
    
    /**
     * value: NETHERLANDS
     * @const
     */
    NETHERLANDS: "NETHERLANDS",
    
    /**
     * value: NIGERIA
     * @const
     */
    NIGERIA: "NIGERIA",
    
    /**
     * value: NORTHERN_IRELAND
     * @const
     */
    NORTHERN_IRELAND: "NORTHERN_IRELAND",
    
    /**
     * value: NORWAY
     * @const
     */
    NORWAY: "NORWAY",
    
    /**
     * value: PAKISTAN
     * @const
     */
    PAKISTAN: "PAKISTAN",
    
    /**
     * value: PANAMA
     * @const
     */
    PANAMA: "PANAMA",
    
    /**
     * value: PERU
     * @const
     */
    PERU: "PERU",
    
    /**
     * value: PHILIPPINES
     * @const
     */
    PHILIPPINES: "PHILIPPINES",
    
    /**
     * value: POLAND
     * @const
     */
    POLAND: "POLAND",
    
    /**
     * value: PORTUGAL
     * @const
     */
    PORTUGAL: "PORTUGAL",
    
    /**
     * value: PUERTO_RICO
     * @const
     */
    PUERTO_RICO: "PUERTO_RICO",
    
    /**
     * value: ROMANIA
     * @const
     */
    ROMANIA: "ROMANIA",
    
    /**
     * value: RUSSIA
     * @const
     */
    RUSSIA: "RUSSIA",
    
    /**
     * value: SAUDI_ARABIA
     * @const
     */
    SAUDI_ARABIA: "SAUDI_ARABIA",
    
    /**
     * value: SCOTLAND
     * @const
     */
    SCOTLAND: "SCOTLAND",
    
    /**
     * value: SENEGAL
     * @const
     */
    SENEGAL: "SENEGAL",
    
    /**
     * value: SINGAPORE
     * @const
     */
    SINGAPORE: "SINGAPORE",
    
    /**
     * value: SLOVAKIA
     * @const
     */
    SLOVAKIA: "SLOVAKIA",
    
    /**
     * value: SLOVENIA
     * @const
     */
    SLOVENIA: "SLOVENIA",
    
    /**
     * value: SOUTH_AFRICA
     * @const
     */
    SOUTH_AFRICA: "SOUTH_AFRICA",
    
    /**
     * value: SPAIN
     * @const
     */
    SPAIN: "SPAIN",
    
    /**
     * value: SUDAN
     * @const
     */
    SUDAN: "SUDAN",
    
    /**
     * value: SWEDEN
     * @const
     */
    SWEDEN: "SWEDEN",
    
    /**
     * value: SWITZERLAND
     * @const
     */
    SWITZERLAND: "SWITZERLAND",
    
    /**
     * value: TAIWAN
     * @const
     */
    TAIWAN: "TAIWAN",
    
    /**
     * value: THAILAND
     * @const
     */
    THAILAND: "THAILAND",
    
    /**
     * value: TUNISIA
     * @const
     */
    TUNISIA: "TUNISIA",
    
    /**
     * value: TURKEY
     * @const
     */
    TURKEY: "TURKEY",
    
    /**
     * value: UKRAINE
     * @const
     */
    UKRAINE: "UKRAINE",
    
    /**
     * value: UNITED_ARAB_EMIRATES
     * @const
     */
    UNITED_ARAB_EMIRATES: "UNITED_ARAB_EMIRATES",
    
    /**
     * value: UNITED_STATES
     * @const
     */
    UNITED_STATES: "UNITED_STATES",
    
    /**
     * value: UZBEKISTAN
     * @const
     */
    UZBEKISTAN: "UZBEKISTAN",
    
    /**
     * value: VENEZUELA
     * @const
     */
    VENEZUELA: "VENEZUELA",
    
    /**
     * value: VIETNAM
     * @const
     */
    VIETNAM: "VIETNAM",
    
    /**
     * value: WALES
     * @const
     */
    WALES: "WALES"
  };  /**
   * Allowed values for the <code>language</code> property.
   * @enum {String}
   * @readonly
   */
  exports.LanguageEnum = { 
    /**
     * value: AZERBAIJANI
     * @const
     */
    AZERBAIJANI: "AZERBAIJANI",
    
    /**
     * value: BENGALI
     * @const
     */
    BENGALI: "BENGALI",
    
    /**
     * value: BULGARIAN
     * @const
     */
    BULGARIAN: "BULGARIAN",
    
    /**
     * value: CATALAN
     * @const
     */
    CATALAN: "CATALAN",
    
    /**
     * value: CHINESE_SIMPLIFIED
     * @const
     */
    CHINESE_SIMPLIFIED: "CHINESE_SIMPLIFIED",
    
    /**
     * value: CHINESE_TRADITIONAL
     * @const
     */
    CHINESE_TRADITIONAL: "CHINESE_TRADITIONAL",
    
    /**
     * value: CROATIAN
     * @const
     */
    CROATIAN: "CROATIAN",
    
    /**
     * value: CZECH
     * @const
     */
    CZECH: "CZECH",
    
    /**
     * value: DANISH
     * @const
     */
    DANISH: "DANISH",
    
    /**
     * value: DUTCH
     * @const
     */
    DUTCH: "DUTCH",
    
    /**
     * value: EGYPTIAN_ARABIC
     * @const
     */
    EGYPTIAN_ARABIC: "EGYPTIAN_ARABIC",
    
    /**
     * value: ENGLISH_UK
     * @const
     */
    ENGLISH_UK: "ENGLISH_UK",
    
    /**
     * value: ENGLISH_US
     * @const
     */
    ENGLISH_US: "ENGLISH_US",
    
    /**
     * value: ESTONIAN
     * @const
     */
    ESTONIAN: "ESTONIAN",
    
    /**
     * value: FINNISH
     * @const
     */
    FINNISH: "FINNISH",
    
    /**
     * value: FRENCH
     * @const
     */
    FRENCH: "FRENCH",
    
    /**
     * value: GERMAN
     * @const
     */
    GERMAN: "GERMAN",
    
    /**
     * value: GREEK
     * @const
     */
    GREEK: "GREEK",
    
    /**
     * value: HAUSA
     * @const
     */
    HAUSA: "HAUSA",
    
    /**
     * value: HEBREW
     * @const
     */
    HEBREW: "HEBREW",
    
    /**
     * value: HINDI
     * @const
     */
    HINDI: "HINDI",
    
    /**
     * value: HUNGARIAN
     * @const
     */
    HUNGARIAN: "HUNGARIAN",
    
    /**
     * value: INDONESIAN
     * @const
     */
    INDONESIAN: "INDONESIAN",
    
    /**
     * value: ITALIAN
     * @const
     */
    ITALIAN: "ITALIAN",
    
    /**
     * value: JAPANESE
     * @const
     */
    JAPANESE: "JAPANESE",
    
    /**
     * value: JAVANESE
     * @const
     */
    JAVANESE: "JAVANESE",
    
    /**
     * value: KOREAN
     * @const
     */
    KOREAN: "KOREAN",
    
    /**
     * value: LATVIAN
     * @const
     */
    LATVIAN: "LATVIAN",
    
    /**
     * value: LITHUANIAN
     * @const
     */
    LITHUANIAN: "LITHUANIAN",
    
    /**
     * value: NORWEGIAN
     * @const
     */
    NORWEGIAN: "NORWEGIAN",
    
    /**
     * value: PERSIAN
     * @const
     */
    PERSIAN: "PERSIAN",
    
    /**
     * value: POLISH
     * @const
     */
    POLISH: "POLISH",
    
    /**
     * value: PORTUGUESE
     * @const
     */
    PORTUGUESE: "PORTUGUESE",
    
    /**
     * value: ROMANIAN
     * @const
     */
    ROMANIAN: "ROMANIAN",
    
    /**
     * value: RUSSIAN
     * @const
     */
    RUSSIAN: "RUSSIAN",
    
    /**
     * value: SERBIAN
     * @const
     */
    SERBIAN: "SERBIAN",
    
    /**
     * value: SLOVAK
     * @const
     */
    SLOVAK: "SLOVAK",
    
    /**
     * value: SLOVENIAN
     * @const
     */
    SLOVENIAN: "SLOVENIAN",
    
    /**
     * value: SPANISH
     * @const
     */
    SPANISH: "SPANISH",
    
    /**
     * value: STANDARD_ARABIC
     * @const
     */
    STANDARD_ARABIC: "STANDARD_ARABIC",
    
    /**
     * value: SWAHILI
     * @const
     */
    SWAHILI: "SWAHILI",
    
    /**
     * value: SWEDISH
     * @const
     */
    SWEDISH: "SWEDISH",
    
    /**
     * value: THAI
     * @const
     */
    THAI: "THAI",
    
    /**
     * value: TURKISH
     * @const
     */
    TURKISH: "TURKISH",
    
    /**
     * value: UKRAINIAN
     * @const
     */
    UKRAINIAN: "UKRAINIAN",
    
    /**
     * value: VIETNAMESE
     * @const
     */
    VIETNAMESE: "VIETNAMESE",
    
    /**
     * value: ZULU
     * @const
     */
    ZULU: "ZULU"
  };  /**
   * Allowed values for the <code>lppVersion</code> property.
   * @enum {String}
   * @readonly
   */
  exports.LppVersionEnum = { 
    /**
     * value: TWO_POINT_ZERO
     * @const
     */
    TWO_POINT_ZERO: "TWO_POINT_ZERO",
    
    /**
     * value: ONE_POINT_FOUR
     * @const
     */
    ONE_POINT_FOUR: "ONE_POINT_FOUR"
  };  /**
   * Allowed values for the <code>resourceType</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ResourceTypeEnum = { 
    /**
     * value: IMAGE
     * @const
     */
    IMAGE: "IMAGE",
    
    /**
     * value: PDF
     * @const
     */
    PDF: "PDF",
    
    /**
     * value: POWERPOINT
     * @const
     */
    POWERPOINT: "POWERPOINT",
    
    /**
     * value: NOTEBOOK
     * @const
     */
    NOTEBOOK: "NOTEBOOK",
    
    /**
     * value: PAGE_SVG
     * @const
     */
    PAGE_SVG: "PAGE_SVG",
    
    /**
     * value: XML
     * @const
     */
    XML: "XML",
    
    /**
     * value: JSON
     * @const
     */
    JSON: "JSON",
    
    /**
     * value: GALLERY
     * @const
     */
    GALLERY: "GALLERY",
    
    /**
     * value: PUBLISHER
     * @const
     */
    PUBLISHER: "PUBLISHER",
    
    /**
     * value: TEXT
     * @const
     */
    TEXT: "TEXT",
    
    /**
     * value: ZIP
     * @const
     */
    ZIP: "ZIP",
    
    /**
     * value: CARTRIDGE
     * @const
     */
    CARTRIDGE: "CARTRIDGE",
    
    /**
     * value: AMP_WORKSPACE
     * @const
     */
    AMP_WORKSPACE: "AMP_WORKSPACE",
    
    /**
     * value: WORKSPACE
     * @const
     */
    WORKSPACE: "WORKSPACE",
    
    /**
     * value: LESSONS
     * @const
     */
    LESSONS: "LESSONS",
    
    /**
     * value: WORKSPACE_HOLDER
     * @const
     */
    WORKSPACE_HOLDER: "WORKSPACE_HOLDER",
    
    /**
     * value: WIDGET
     * @const
     */
    WIDGET: "WIDGET",
    
    /**
     * value: WIDGET_PACKAGE
     * @const
     */
    WIDGET_PACKAGE: "WIDGET_PACKAGE",
    
    /**
     * value: UNDEFINED
     * @const
     */
    UNDEFINED: "UNDEFINED"
  };

  return exports;
}));
